export default __webpack_public_path__ + "e484e1b151f068cfa4e35f07a0a4af01.woff2";